import FileSaver from "file-saver";
import { getToken } from "../utils/authUtils";
import { parseJSON } from "./parseJSON";
import { handleErrors } from "./handleErrors";

const urlBase = `${process.env.API_URL}/subclient`;
const urlClient = `${process.env.API_URL}/client`;
const readUrl = (url = "") => `${urlBase}${url}`;
const readUrlClient = (url = "") => `${urlClient}${url}`;

export const fetchSubclientsPaginados = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams(params);

  let res = await fetch(readUrl(`?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);
  return res.success;
};

export const fetchClient = async (ClientId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrlClient(`/${ClientId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success.result;
};

export const fetchSubclient = async (subclientId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${subclientId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success.result;
};
export const fetchAllSubclientWithTickets = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/allwithtickets`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchCalendar = async (calendarBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("/calendar"), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(calendarBody),
  });

  res = await parseJSON(res);

  return res.success;
};

export const createSubclient = async (infoBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(``), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(infoBody),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchSubclient = async (subclientId, infoBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/${subclientId}`), {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(infoBody),
  });

  res = await parseJSON(res);

  return res.success;
};

export const patchSubclientArea = async (subclientId, areaId, areaBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`${subclientId}/${areaId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(areaBody),
  });

  res = await parseJSON(res);

  return res.success;
};

export const postSubclientArea = async (areaBody) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl("/area"), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(areaBody),
  });

  res = await parseJSON(res);

  return res.success.result;
};

export const getSubclientesCentralizados = async (area, ClientId) => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/centralizado?area=${area}&ClientId=${ClientId}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const fetchDeliverDateCategorias = async () => {
  const auth = `Bearer ${getToken()}`;

  let res = await fetch(readUrl(`/categories`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const subclientsKpis = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams();
  query.append("startDate", params.startDate);
  query.append("endDate", params.endDate);

  let res = await fetch(readUrl(`/relevamientosKpiCN?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  res = await parseJSON(res);

  return res.success;
};

export const importRelevamientosCN = async (params) => {
  const auth = `Bearer ${getToken()}`;

  const query = new URLSearchParams();
  query.append("startDate", params[0].startDate);
  query.append("endDate", params[0].endDate);

  const res = await fetch(readUrl(`/relevamientosCN?${query.toString()}`), {
    method: "GET",
    headers: {
      Accept: "application/json",
      Authorization: auth,
      "Content-Type": "application/json",
    },
  });

  const blob = await res.blob();
  const blobToCSV = (blobs) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const text = reader.result;
        const adjustedCSV = `SEP=,\n${text.replace(/\.0000/g, "")}`;
        const csvContent = `\uFEFF${adjustedCSV}`;
        resolve(csvContent);
      };
      reader.onerror = reject;
      // Especificar la codificación de caracteres UTF-8 al leer el Blob como texto
      reader.readAsText(blobs, "UTF-8");
    });
  };

  try {
    // Convertir el Blob en texto CSV correctamente formateado
    const adjustedCSV = await blobToCSV(blob);

    const csvBlob = new Blob([adjustedCSV], { type: "text/csv;charset=UTF-8" });
    FileSaver.saveAs(csvBlob, "PIN-RelevamientosCN.csv");

    return true;
  } catch (error) {
    handleErrors(error);
    return false;
  }
};

export const uploadResponsables = async ({ files }) => {
  const auth = `Bearer ${getToken()}`;

  const formData = new FormData();
  Array.from(files).forEach((file) => {
    formData.append("responsables", file);
  });

  const res = await fetch(readUrl(`/bulk-responsables-import`), {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: auth,
    },
    body: formData,
  });
  const response = await res.json();
  if (res.status >= 200 && res.status < 300) {
    return response;
  }
  throw response;
};
